module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('AdvancedFilter', {

		configure: function () {

			this.registerOptions('', {
				autoRender: true,
				template: 'advancedFilter',
				'embed.container': '.filter-wrapper',
				handleDom: {
					toggle: {
						target: '.filter-title',
						event: 'click',
						callback: 'toggleFilter'
					},
					applyFilters: {
						target: '#set-filter',
						event: 'click',
						callback: 'apply'
					},
					reset: {
						target: '#reset-filter',
						event: 'click',
						callback: 'reset'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		addedToDom: function() {
			this.fromNavigator();
		},

		running: function () {
			this.isOpened = false;
			this.callParent('running', arguments);
		},


		toggleFilter: function (el) {
			fox.dom[(this.isOpened ? 'removeClass' : 'addClass')]('expanded', this.dom1('.advanced-filter'));
			this.isOpened = !this.isOpened;
		},

		collectData: function () {
			this.filters = {};

			fox.each(this.dom('input[name]'), function (input) {
				input = fox.dom.wrap(input);
				if (fox.isEmpty(input.val())) {
					delete this.filters[input.attr('name')];
				}
			}, this);

			fox.each(this.dom('input[name]:checked'), function (input) {
				input = fox.dom.wrap(input);
				this.filters[input.attr('name')] = input.val().split(',');
			}, this);

			fox.each(this.wom('~.Control_Select'), function (w) {
				if (!fox.isEmpty(w.getValue())) {

					this.filters[w.getAlias()] = fox.isArray(w.getValue()) ? 
					w.getValue() :
					w.getValue().split(',');
				} else {
					delete this.filters[w.getAlias()];
				}
			}, this);

			fox.each(this.wom('~.Autocomplete2'), function (w) {
				if (!fox.isEmpty(w.getValue())) {
					this.filters[w.getAlias()] = w.getValue();
				} else {
					delete this.filters[w.getAlias()];
				}
				
			}, this);

			return this.filters;
		},

		apply: function () {
			this.collectData();
			this.toNavigator();
			this.dispatchEvent('apply', this.filters);
		},

		reset: function () {
			this.filters = {};

			fox.each(this.dom('input[name]'), function (input) {
				input.value = '';
			}, this);

			fox.each(this.wom('~.Control_Select'), function (w) {
				w.reset();
			}, this);

			fox.each(this.wom('~.Autocomplete2'), function (w) {
				w.reset();
			}, this);

			this.dispatchEvent('reset');
		},

		setValue: function () {

			if (fox.isObject(arguments[0])) {
				fox.each(arguments[0], function (val, alias) {
					this._setValue(alias, val, (arguments[1] || {}));
				}, this);
				return;
			}

			if (fox.isString(arguments[0]) && !fox.isEmpty(arguments[1])) {
				this._setValue(arguments[0], arguments[1], (arguments[2] || {}));
				return;
			}
		},

		_setValue: function (alias, value, params) {
			var w = this.wom1('#' + alias);

			if (!w) {
				var input = this.dom('input[name]');

				fox.each(input, function(el){
					if (el.type === ('checkbox')) {
						if (el.value === value.join(',')) {
							el.checked = true;
						}
					} else {
						el.value = value;
					}

				}, this);
				return;
			}

			if (fox.oop.instanceOf(w, 'Control_Select')) {
				w.setValue(value);
				return;
			}

			if (fox.oop.instanceOf(w, 'Autocomplete2_MultipleSelect')) {
				if (w.wom1('#list').isEmbedded()){
					w.setValue(value, params);
				} else {
					this.waitEvent(w.wom1('#list'), 'addedToDom', function(){
						w.setValue(value, params);
					}, this);
				}

				return;
			}

			if (fox.oop.instanceOf(w, 'Autocomplete2')) {
				w.fillInput(value);
				w.search(value);

				return;
			}
		},

		toNavigator: function() {
			fox.Navigator.reset();
			fox.Navigator.set(0, 'oursites');
			fox.Navigator.bulkSet(this.filters);
		},
		
		fromNavigator: function () {
			var res = {}; 
			this.filters = {};
			fox.each(fox.Navigator.getAll(), function(val, key) {
				if (!fox.isNumeric(key)) {
					this.setValue(key, val.split(","));
					this.filters[key] = val.split(",");
				}
			}, this);

			this.dispatchEvent('apply', this.filters);

		},

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/advancedFilter.js
// module id = 194
// module chunks = 5